import React from 'react';
import useIsMobile from '../../../hooks/useIsMobile';

interface LoadingOverlayProps {
  message?: string;
}

/**
 * A loading overlay component that displays a spinner and message
 * over its parent container
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message = 'Loading forecast data...' }) => {
  const isMobile = useIsMobile();

  return (
    <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded-lg shadow-lg">
        <div className={`text-center ${isMobile ? 'text-base font-medium' : ''}`}>
          <div className="flex items-center justify-center">
            <svg className="animate-spin h-5 w-5 mr-2 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;